import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-item" }
const _hoisted_2 = { class: "offset-panel" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "numbers-grid" }
const _hoisted_5 = { class: "reset-container" }

import { ref, watch, computed } from 'vue';

// 定义组件props

export default /*@__PURE__*/_defineComponent({
  __name: 'ScoreRangeFilter',
  props: {
    passLineOffset: {},
    selectedLineGroupId: {},
    passLineList: {}
  },
  emits: ["update:passLineOffset", "update:selectedLineGroupId", "filterChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// 定义组件事件
const emit = __emit;

// 状态管理
const scoreLineVisible = ref(false);
const offsetVisible = ref(false);
const customOffset = ref<number>();
const selectedOffset = ref<number | null>(null);
const offsetNumbers = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

// 动态计算当前选中的偏移量文本
const currentOffsetText = computed(() => {
  return selectedOffset.value !== null && selectedOffset.value !== undefined 
    ? `${selectedOffset.value}分` 
    : '上下范围';  
});

// 动态计算当前选中的分数线文本
const currentPassLineText = computed(() => {
  if (props.selectedLineGroupId === null || props.selectedLineGroupId === '') {
    return '选择分数线';
  }
  const selectedLine = props.passLineList.find(line => line.id === props.selectedLineGroupId);
  return selectedLine ? selectedLine.line_name : '选择分数线';
});

// 监听props变化
watch(() => props.selectedLineGroupId, (val) => {
  if (val === null || val === '') {
    resetOffsetValues();
  } else {
    setDefaultOffset();
  }
});

// 重置偏移量选择
const resetOffsetValues = () => {
  customOffset.value = undefined;
  selectedOffset.value = null;
};

// 设置默认偏移量为10的方法
const setDefaultOffset = () => {
  selectedOffset.value = 10;
  customOffset.value = 10;
  emit('update:passLineOffset', 10);
  emit('filterChange', { offset: 10 });
};

// 处理重置按钮
const handleReset = () => {
  resetOffsetValues();
  emit('update:passLineOffset', 0);
  emit('filterChange', { offset: null });
  offsetVisible.value = false;
};

// 分数线筛选显示控制
const handleScoreLineVisibleChange = (visible: boolean) => {
  scoreLineVisible.value = visible;
  if (visible) offsetVisible.value = false;
};

// 偏移量筛选显示控制
const handleOffsetVisibleChange = (visible: boolean) => {
  offsetVisible.value = visible;
  if (visible) scoreLineVisible.value = false;
};

// 分数线选择处理
const handleScoreLineSelect = ({ key }: { key: string }) => {
  const selectedId = key === '' ? null : key;
  emit('update:selectedLineGroupId', selectedId);
  
  // 选择具体分数线时设置默认偏移量
  if (selectedId) {
    setDefaultOffset();
    emit('filterChange', { id: selectedId, offset: 10 });
  } else {
    emit('filterChange', {});
  }
  
  scoreLineVisible.value = false;
};

// 自定义偏移量输入处理
const handleCustomInputChange = (value: number) => {
  if (value !== null && value !== undefined) {
    selectedOffset.value = value;
    emit('update:passLineOffset', value);
    emit('filterChange', { offset: value });
  }
};

// 数字选项选择处理
const handleNumberSelect = (num: number) => {
  selectedOffset.value = num;
  customOffset.value = num;
  emit('update:passLineOffset', num);
  emit('filterChange', { offset: num });
};

return (_ctx: any,_cache: any) => {
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "filter-label" }, "分数线筛选：", -1)),
    _createVNode(_component_a_dropdown, {
      visible: scoreLineVisible.value,
      onVisibleChange: handleScoreLineVisibleChange,
      placement: "bottomLeft"
    }, {
      overlay: _withCtx(() => [
        _createVNode(_component_a_menu, { onClick: handleScoreLineSelect }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("不选择分数线", -1)
              ]))]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.passLineList, (line) => {
              return (_openBlock(), _createBlock(_component_a_menu_item, {
                key: line.id,
                value: line.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(line.line_name.slice(4)) + "(" + _toDisplayString(line['总分']) + "分) ", 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: _normalizeClass(["filter-btn", { 'active': scoreLineVisible.value }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(currentPassLineText.value) + " ", 1),
            _createVNode(_component_a_icon, {
              type: "caret-down",
              rotate: scoreLineVisible.value ? 180 : 0
            }, null, 8, ["rotate"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_dropdown, {
      visible: offsetVisible.value,
      onVisibleChange: handleOffsetVisibleChange,
      placement: "bottomLeft",
      disabled: !props.selectedLineGroupId
    }, {
      overlay: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_input_number, {
              value: customOffset.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((customOffset).value = $event)),
              placeholder: "输入上下范围",
              class: "custom-input",
              min: 0,
              onChange: handleCustomInputChange
            }, null, 8, ["value"])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider" }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(offsetNumbers, (num) => {
              return _createVNode(_component_a_button, {
                key: num,
                class: _normalizeClass(["number-btn", { 'selected': selectedOffset.value === num }]),
                onClick: ($event: any) => (handleNumberSelect(num))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(num) + "分 ", 1)
                ]),
                _: 2
              }, 1032, ["class", "onClick"])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_button, {
              class: "reset-btn",
              onClick: handleReset
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" 重置 ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: _normalizeClass(["filter-btn", {
          'active': offsetVisible.value,
          'disabled': !props.selectedLineGroupId
        }]),
          disabled: !props.selectedLineGroupId
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(currentOffsetText.value) + " ", 1),
            _createVNode(_component_a_icon, {
              type: "caret-down",
              rotate: offsetVisible.value ? 180 : 0
            }, null, 8, ["rotate"])
          ]),
          _: 1
        }, 8, ["class", "disabled"])
      ]),
      _: 1
    }, 8, ["visible", "disabled"])
  ]))
}
}

})